module.exports = __webpack_public_path__ + "img/Weapon_183.85cdc1d7.png";